const countryOptions = [
  // {
  //   value: 'Japan',
  //   label: '日本',
  // },
  {
    value: 'Mexico',
    label: 'México'
  }, {
    value: 'CostaRica',
    label: 'Costa Rica'
  }
];
const  languageOptionsForCountry = {
  'JP': [
    {
      value: 'ja-JP',
      label: '日本語',
    }
  ],
  'MX': [
    {
      value: 'es-MX',
      label: 'Español'
    }
  ],
  'CR': [
    {
      value: 'es-CR',
      label: 'Español'
    }
  ]
}

const followUSConfig = {
  JP: [
    {
      iconClass: 'iconfont-instagram',
      url: 'https://www.instagram.com/didifoodjp/'
    },
    {
      iconClass: 'iconfont-twitter',
      url: 'https://twitter.com/didifoodjp'
    },
  ],
  MX: [
    {
      iconClass: 'iconfont-facebook',
      url: 'https://www.facebook.com/DiDiFoodMX/?channel_id=wi3dx0als'
    },
    {
      iconClass: 'iconfont-instagram',
      url: 'https://www.instagram.com/didifoodmx/?channel_id=xnp6luaz4'
    },
    {
      iconClass: 'iconfont-twitter',
      url: 'https://twitter.com/DidifoodMX?channel_id=4zcywaul5'
    },
    {
      iconClass: 'iconfont-youtube',
      url: 'https://www.youtube.com/channel/UCRLvyTR8vPVxLXg3NfvpHzQ?channel_id=gq6d3nbdj'
    },
  ]
}

function getLanguageOptionsForCountry(country) {
  const commonOptions = [{
    value: 'en-US',
    label: 'English',
  }]
  let countryOptions = languageOptionsForCountry[country] || []
  return [ ...commonOptions, ...countryOptions ]
}

export{
  countryOptions,
  getLanguageOptionsForCountry,
  followUSConfig
}